import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'signet-pdf-viewer',
  styleUrl: 'signet-pdf-viewer.scss',
  shadow: true,
})
export class SignetPDFViewer {
  @Prop() pdfTitle: string;
  @Prop() imagePreview = '';
  @Prop() image = '';
  @Prop() severity: 'success' | 'error' | 'warning' | 'normal' = 'normal';

  @State() showPreview = true;

  render() {
    const classes = {
      'signet-pdf-viewer': true,
      [this.severity]: true,
    };

    return (
      <div class={classes}>
        <div class="pdf-header">
          <p class="ml-2">{this.pdfTitle}</p>{' '}
          <signet-icon
            icon="fullscreen"
            onClick={() => (this.showPreview = !this.showPreview)}
            class="icon"
          />
        </div>
        <div class="pdf-body">
          {this.showPreview ? (
            <img src={this.imagePreview} alt="image-preview" />
          ) : (
            <img
              src={!this.image ? this.imagePreview : this.image}
              alt="image"
            />
          )}
        </div>
      </div>
    );
  }
}
